import { emitter } from './common'

const elem: HTMLElement = document.querySelector('.loader') as HTMLElement
emitter.on('ready', () => {
  if (elem) {
    elem.classList.add('fadeOut')
    setTimeout(() => (elem.style.display = 'none'), 700)
  }
})
